import './validation'
// Shop Landing Page Elements
var productsContainer = document.querySelector('.shop-grid');
var productTypesSelectors = document.querySelectorAll('input[name="productType"]');

// End of Shop Landing Page Elements

// Product Detail Page elements
const productDetailPage = document.querySelector('.product-detail-page');
const priceDisplay = document.querySelector('#priceDisplay');
const productPrice = document.querySelector('#productPrice');
const btnAddToCart = productDetailPage?.querySelector('.btn-addToCart');
const quantityInput = productDetailPage?.querySelector('#quantity');
const btnIncreaseQuantity = productDetailPage?.querySelector('.js-btnIncreaseQty');
const btnDecreaseQuantity = productDetailPage?.querySelector('.js-btnDecreaseQty');
// End of Product Detail Page Elements


// Cart Checkout Page elements
const shopCheckoutSection = document.querySelector('section.shop-checkout');
const differentInvoiceEmailCheckbox = shopCheckoutSection?.querySelector('#Purchaser_IsInvoiceEmailDifferent');
const invoiceEmailInput = shopCheckoutSection?.querySelector('.js-invoice-email-field');
// End of Cart Checkout Page elements

function formatNumber(value) {
    const n = parseFloat(value);

    return n % 1 === 0
        ? n.toString()
        : n.toFixed(2).replace(/\.?0+$/, "");


}
function updatePrice() {
    let price = parseFloat(productPrice.value);
    if (price > 0) {
        let totalPrice = parseInt(quantityInput.value) * price;
        priceDisplay.textContent = `$${formatNumber(totalPrice)}`;
    }
}


document.addEventListener('DOMContentLoaded', function () {

    // Shop Landing Page 
    productTypesSelectors?.forEach(function (selector) {
        selector.addEventListener('change', function (event) {
            var selectedType = event.target.value;
            var show = event.target.checked;
            var products = productsContainer.querySelectorAll('.product-item');
            products.forEach(function (product) {
                if (product.dataset.type === selectedType) {
                    product.style.display = show ? 'block' : 'none';
                }
            });
        });
    });






    // End of Shop Landing Page

    // Product Detail Page
    if (productDetailPage) {
        // initialize quantity input
        if (quantityInput)
            quantityInput.value = 1;

    btnIncreaseQuantity?.addEventListener('click', function (event) {
        event.preventDefault();
        let currentQuantity = parseInt(quantityInput.value);
        quantityInput.value = currentQuantity + 1;
        updatePrice();

        });

    btnDecreaseQuantity?.addEventListener('click', function () {
        event.preventDefault();
        let currentQuantity = parseInt(quantityInput.value);
        if (currentQuantity > 1) {
            quantityInput.value = currentQuantity - 1;
        }
        updatePrice();
    });


        quantityInput?.addEventListener('change', function () {
            updatePrice();
        })
    }
    // End of Product Detail Page

    // Cart Checkout Page
    if (shopCheckoutSection) {
        differentInvoiceEmailCheckbox?.addEventListener('change', function () {
            invoiceEmailInput.style.display = this.checked ? 'block' : 'none';
        });
    }
    // End of Cart Checkout Page
});
